import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDevices = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4 20h9V8H4v12zm9-15a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v1h9V5zm-4.832 5.445a1 1 0 1 1 1.664 1.11L8.869 13H10a1 1 0 0 1 .832 1.555l-2 3a1 1 0 1 1-1.664-1.11L8.131 15H7a1 1 0 0 1-.832-1.555l2-3zM15 12h1a3 3 0 0 1 3 3v2a1 1 0 0 0 2 0v-6.999a1 1 0 0 0-.295-.71l-.02-.02-3.41-3.582a1 1 0 1 1 1.45-1.378l3.39 3.562.103.107A3 3 0 0 1 23 10.002V17a3 3 0 0 1-6 0v-2a1 1 0 0 0-1-1h-1v6a1 1 0 1 1 0 2H2a1 1 0 1 1 0-2V5a3 3 0 0 1 3-3h7a3 3 0 0 1 3 3v7z",
		fill: "currentColor"
	})
});
export default SvgDevices;
